
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_2960_8528)"}},[_c('rect',{attrs:{"width":"40","height":"40","rx":"4","fill":"#30B267"}}),_c('path',{attrs:{"d":"M23 23l-2 5-4-11 11 4-5 2zm0 0l5 5M15.188 10.239l.777 2.897m-2.829 2.829l-2.898-.777M21.95 12.05l-2.122 2.122m-5.656 5.656L12.05 21.95","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_2960_8528"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h40v40H0z"}})])])])
          )
        }
      }
    